import React, { useState, useEffect } from 'react';
import { PageHeader, Btn, Badge, Table, Modal, Input, Select } from '../../components/UI';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function Campaigns() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ name: '', message: '', audience_type: 'all', audience_tag: 'hot', scheduled_at: '' });
  const [sendType, setSendType] = useState('now');
  const [saving, setSaving] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get('/api/campaigns'); if (data.success) setCampaigns(data.campaigns); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const payload = { ...form, scheduled_at: sendType === 'schedule' ? form.scheduled_at : null };
      const { data } = await api.post('/api/campaigns', payload);
      if (data.success) { toast.success('Campaign created!'); setModal(false); load(); }
      else toast.error(data.message);
    } finally { setSaving(false); }
  };

  const del = async (id) => {
    if (!window.confirm('Delete this campaign?')) return;
    await api.delete('/api/campaigns/' + id);
    toast.success('Deleted'); load();
  };

  return (
    <div>
      <PageHeader title="Campaign Manager" action={<Btn onClick={() => setModal(true)}>➕ New Campaign</Btn>} />
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
        <Table loading={loading} emptyMsg="No campaigns yet. Create your first campaign!"
          columns={[
            { key: 'name', label: 'Campaign Name', render: (v, r) => <div><div style={{ fontWeight: 600 }}>{v}</div><div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{r.message?.substring(0, 40)}...</div></div> },
            { key: 'audience_type', label: 'Audience', render: (v, r) => v === 'all' ? 'All Contacts' : r.audience_tag },
            { key: 'scheduled_at', label: 'Scheduled', render: v => v ? new Date(v).toLocaleDateString('en-IN') : 'Immediate' },
            { key: 'status', label: 'Status', render: v => <Badge>{v}</Badge> },
            { key: 'total_sent', label: '✔ Sent', render: v => <span style={{ color: 'var(--green)', fontWeight: 600 }}>{v || 0}</span> },
            { key: 'total_delivered', label: '✔✔ Delivered', render: v => v || 0 },
            { key: 'total_read', label: '🔵 Read', render: v => <span style={{ color: '#4da8ff' }}>{v || 0}</span> },
            { key: 'total_failed', label: '❌ Failed', render: v => <span style={{ color: '#ff6b6b' }}>{v || 0}</span> },
            { key: 'id', label: 'Actions', render: (v) => <button onClick={() => del(v)} style={{ background: 'rgba(255,68,68,0.1)', color: '#ff6b6b', border: 'none', padding: '5px 10px', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>🗑</button> },
          ]}
          data={campaigns}
        />
      </div>

      <Modal open={modal} onClose={() => setModal(false)} title="📤 Create Campaign" width={540}>
        <form onSubmit={save}>
          <Input label="Campaign Name *" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Diwali Offer 2026" required />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Select label="Audience" value={form.audience_type} onChange={e => setForm({ ...form, audience_type: e.target.value })} options={[{ value: 'all', label: 'All Contacts' }, { value: 'tag', label: 'By Tag' }]} />
            {form.audience_type === 'tag' && <Select label="Tag" value={form.audience_tag} onChange={e => setForm({ ...form, audience_tag: e.target.value })} options={[{ value: 'hot', label: 'Hot' }, { value: 'warm', label: 'Warm' }, { value: 'cold', label: 'Cold' }, { value: 'customer', label: 'Customer' }]} />}
            <Select label="Send" value={sendType} onChange={e => setSendType(e.target.value)} options={[{ value: 'now', label: 'Send Immediately' }, { value: 'schedule', label: 'Schedule Later' }]} />
            {sendType === 'schedule' && <Input label="Schedule Date & Time" type="datetime-local" value={form.scheduled_at} onChange={e => setForm({ ...form, scheduled_at: e.target.value })} />}
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 6, fontWeight: 500 }}>Message * (Use {'{name}'} for personalization)</label>
            <textarea value={form.message} onChange={e => { setForm({ ...form, message: e.target.value }); setCharCount(e.target.value.length); }} placeholder={"Hi {name}! We have an exciting offer for you..."} style={{ width: '100%', height: 140, background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: 12, color: 'var(--text)', resize: 'none', fontSize: 13 }} required />
            <div style={{ textAlign: 'right', fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>{charCount} characters</div>
          </div>
          <div style={{ display: 'flex', gap: 12 }}>
            <Btn type="submit" disabled={saving} full>{saving ? 'Creating...' : 'Create Campaign'}</Btn>
            <Btn variant="outline" onClick={() => setModal(false)} full>Cancel</Btn>
          </div>
        </form>
      </Modal>
    </div>
  );
}